<template>
	<data-loader :url="`/v1/view/articles`"
				 :on-scroll="true"
				 :params="params">

		<template #loading>
			<row tight>
				<column cols="12" sm="6" md="6" lg="4" v-for="articleLoader in params.limit" :key="'article-loader-' + articleLoader">
					<article-card-skeleton/>
				</column>
			</row>
		</template>

		<template v-slot="{data}">
			<row tight v-adapt:height="{selector: '.article-card', xs: 12, sm: 6, md: 6, lg: 4, xl: 4}">
				<column cols="12" sm="6" md="6" lg="4" v-for="(article, articleKey) in data" :key="'article-preview-' + articleKey">
					<article-card :article="article" class="article-card" xs-tile/>
				</column>
			</row>
		</template>

		<template #missingsearch>
			<lazy-missing-info :text="$t('missing.article.search')" card class="min-h-200"/>
		</template>
		<template #missing>
			<lazy-missing-info :text="$t('missing.article.index')" card class="min-h-200"/>
		</template>
	</data-loader>
</template>

<script setup lang="ts">
import {useUserStore} from "../../../store/user";

const userStore = useUserStore();
const {$date} = useNuxtApp();
const route = useRoute();
const {t} = useI18n();

const params = {
	user_id: userStore.user.id,
	type: 'blog',
	limit: 9,
	ts: userStore.user.blog_cache_buster
};

useMeta({
	title: userStore.buildPageTitle(t('view.users.blog.index.title', {user: userStore.user.display_name})),
	description: t('view.users.blog.index.description', {user: userStore.user.display_name}),
})
</script>
